import React, { Component } from 'react'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBAlert, MDBSelect , MDBInput, MDBIcon  } from 'mdbreact';
import { MDBSelectInput, MDBSelectOptions, MDBSelectOption } from "mdbreact";
import Axios from 'axios'
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip  } from 'antd';
import Swal from 'sweetalert2'
import { URL,api } from '../api';

export default class Modaladdtex extends Component {
    constructor(props) {
        super(props);
        this.state = {
          modal: false,

          inside:"",
          faculty:"",
          Expert:[],
          idExpert:"",
          send_comment1:"",
          success:"",
          filecomment1:null,

          id_send:"",
          id_comment:"",
          id_bn:"",
          show:"",
          comment_admin:"",

          email_Forgot:"",
          tel_Forgot:"",


          tax:"",



        }

this.handleChange = this.handleChange.bind(this);
this.handleSubmit = this.handleSubmit.bind(this);
this.toggle = this.toggle.bind(this);
this.handleChangetype = this.handleChangetype.bind(this);
this.handleChangetype2 = this.handleChangetype2.bind(this);
this.linenotify = this.linenotify.bind(this);
}


toggle = () => {
  this.setState({
    modal: !this.state.modal
  });
  //this.props.selectatf();
}

handleChangetype(event) {    this.setState({tax: event.target.value});  }
handleChangetype2(event) {    this.setState({tel_Forgot: event.target.value});  }


 componentDidMount() {
    //  const { id_send } = this.props.id_send
    //  console.log(this.props.id_send);
   //   this.setState({   id_send:this.props.id_send,
                        // id_comment:this.props.id_comment,
                        // id_bn:this.props.id_bn
                 //   })

  }

  linenotify() {
    setTimeout(() => {
      //ภายใน
      api.post("registercon/linenotify")
      .then(res => {
      //  console.log(res);
      //  this.setState({ bankname: res.data, loading: false })
       // this.setState({ Expert: res.data})
      }) 

    }, 0);

}


  handleChange(event) {    this.setState({show: event.target.value});  }



  handleSubmit= (e) => {
    e.preventDefault();

    const date = new Date();
    const [month, day, year]  = [String(date.getMonth() + 1).padStart(2, '0'), String(date.getDate()).padStart(2, '0'), date.getFullYear()];
    const dates = day+"-"+month+"-"+year ;


   setTimeout(() => {

      const datafrm = new FormData(); 
      datafrm.append("tax", this.state.tax);
      datafrm.append("send_id", this.props.send_id);
    
    

        api.post("registercon/updatetexforuser",datafrm)
            .then(res => {
              console.log("response: ", res)

              if (res.data = '200') {
          


                Swal.fire({
                title: 'เพิ่มเลขผู้เสียภาษี',
                text: "Successfully notified author",
                icon: 'success',
                showCancelButton: false,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'ตกลง'
              }).then((result) => {
                if (result.isConfirmed) {
                   // this.props.list()
                    this.toggle()
                   // this.linenotify()
                         window.location.href = 'https://scitech.kpru.ac.th/csrm2025/system/Homeuser'

                }
              })
              
              }else{
                    message.error("แจ้งลืมรหัสผ่าน ไม่สำเร็จ!")
              }
        
          })

   }, 1000);


  }



  

    render() {

    //  console.log(this.state.show) 
    //  console.log(this.state.comment_admin) 
        
        return (
            <>
            <MDBBtn className='text-center' color="dark-green" onClick={this.toggle} size='sm'>เพิ่มเลขผู้เสียภาษี</MDBBtn>
          {/* <div className="text-center"><a><p onClick={this.toggle} > ลืมรหัสผ่าน</p></a> </div>  */}

            <MDBModal isOpen={this.state.modal} toggle={this.toggle}>
              <MDBModalHeader toggle={this.toggle}><MDBIcon fas  icon="add" /> เพิ่มเลขผู้เสียภาษี </MDBModalHeader>
              <MDBModalBody>

            <h3 className='text-center '> {this.props.agencylisten}</h3>

              <div>
              {/* <p>แจ้งสถานะบทความ</p>
                <select className="browser-default custom-select" onChange={this.handleChange}>
                        <option>------กรุณาเลือกสถานะ------</option>
                        <option value="0">ไม่ส่งแจ้ง</option>
                        <option value="1">ส่งแจ้ง</option>
                </select> */}


                  <form onSubmit={this.handleSubmit}>
                        <div className="mb-2 mt-2 text-left" >
                                    <label><strong>เลขผู้เสียภาษีของหน่วยงาน</strong></label><label className="red-text">*</label>
                                    <input className="form-control" onChange={this.handleChangetype} name="tax"
                                              value={this.state.tax} placeholder="กรุณาระบุเลขผู้เสียภาษีของหน่วยงาน" required />
                        </div>
                        {/* <div className="mb-2 mt-2 text-left">
                                    <label><strong>เบอร์โทรที่ลงทะเบียน</strong></label><label className="red-text">*</label>
                                    <input className="form-control" onChange={this.handleChangetype2} name="tel_Forgot"
                                              value={this.state.tel_Forgot} placeholder="กรุณาระบุเบอร์โทร" required />
                        </div> */}
                       <div className="text-center"><MDBBtn color="primary" type='submit' >บันทึก</MDBBtn></div> 
                  </form>


              </div>
              
              {/* <p className='mt-2'>ระบบจะแจ้งไปยังเจ้าหน้าที่ ทั้งนี้กรุณารอเจ้าหน้าที่ติดต่อกลับ </p> */}
              </MDBModalBody>
              <MDBModalFooter>
                 {/* <MDBBtn color="primary" onClick={this.handleSubmit} >ยืนยัน</MDBBtn> */}
                <MDBBtn color="secondary" size='sm' onClick={this.toggle}>ปิด</MDBBtn>
               
              </MDBModalFooter>
            </MDBModal>
          </>
          
        )
    }
}
